import storage from 'core/pkg/storage'

export default {
  init(options = {}, services) {
    return storage
  }
}
